import { Injectable } from "@angular/core";
import { ErrorService, DataClientErrorMessage } from "./error.service";
export class GlobalErrorHandler {
    constructor(errorService) {
        this.errorService = errorService;
    }
    handleError(error) {
        if (error.rejection instanceof DataClientErrorMessage) {
            let errorMsg = error.rejection;
            if (!errorMsg.validationFailure) {
                this.errorService.reportDataClientError(errorMsg);
            }
        }
        else {
            console.log(error);
            this.errorService.reportError(error);
        }
    }
}
GlobalErrorHandler.decorators = [
    { type: Injectable },
];
/** @nocollapse */
GlobalErrorHandler.ctorParameters = () => [
    { type: ErrorService, },
];
//# sourceMappingURL=global-error.handler.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fedelta-pos/data-client/error/global-error.handler.js
// module id = 217
// module chunks = 1